import { combineReducers } from "redux";

// reducer import
import customizationReducer from "./customizationReducer";
import balanceReducer from "./balanceReducer";
import metricsReducer from "./metricsReducer";
import discussionBoardReducer from "./discussionBoardReducer";

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    customization: customizationReducer,
    balance: balanceReducer,
    metrics: metricsReducer,
    discussionBoard: discussionBoardReducer,
});

export default reducer;
